import { ExpandMore, Save, VideocamOutlined } from "@mui/icons-material";
import { Accordion, AccordionDetails, AccordionSummary, Alert, Box, Button, Snackbar, TextField, Typography } from "@mui/material";
import { useState } from "react";
import { IMarketplace } from "../../../../interfaces/IMarketplace";
import { useMarketplaces } from "../../../../hooks/useMarketplaces";
import { SecaoConfiguracao } from "../../../../../core/components/SecaoConfiguracao";

interface LogRocketContainerProps {
    marketplace: IMarketplace;
    refresh: () => void;
    isLoading: boolean;
}

export const LogRocketContainer = ({ marketplace, refresh }: LogRocketContainerProps) => {
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState("");
    const [appIdInput, setAppIdInput] = useState(
        marketplace?.configuracao?.logRocketAppId ?? ""
    );

    const { salvar, loading } = useMarketplaces();

    const salvarAppId = async () => {
        await salvar({
            ...marketplace,
            configuracao: {
                ...marketplace.configuracao,
                logRocketAppId: appIdInput.trim(),
            }
        });

        refresh();
        setSnackbarMessage("App ID do LogRocket salvo com sucesso");
        setSnackbarOpen(true);
    };

    const fecharSnackbar = () => {
        setSnackbarOpen(false);
    };

    const configurado = !!marketplace?.configuracao?.logRocketAppId;

    return (
        <>
            <SecaoConfiguracao
                titulo="LogRocket"
                descricao={configurado ? "Gravação de sessões ativa" : "Não configurado"}
                icone={<VideocamOutlined />}
                corIcone="#764ABC"
                acoes={
                    <Button
                        size="small"
                        variant="contained"
                        startIcon={<Save />}
                        onClick={salvarAppId}
                        disabled={loading}
                    >
                        Salvar
                    </Button>
                }
            >
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                    <Alert severity="info" variant="outlined" sx={{ borderRadius: "12px" }}>
                        <Typography variant="caption">
                            Grave as sessões dos clientes que acessam o cardápio para analisar o
                            comportamento e identificar problemas de experiência.
                        </Typography>
                    </Alert>

                    <TextField
                        fullWidth
                        size="small"
                        label="App ID do LogRocket"
                        variant="outlined"
                        value={appIdInput}
                        onChange={(e) => setAppIdInput(e.target.value)}
                        placeholder="organizacao/projeto"
                        helperText="Deixe o campo vazio para desativar a gravação neste marketplace"
                        InputProps={{ sx: { fontFamily: "monospace" } }}
                        InputLabelProps={{ shrink: true }}
                    />

                    <Accordion
                        disableGutters
                        elevation={0}
                        sx={{
                            border: theme => `1px solid ${theme.palette.divider}`,
                            "&:before": { display: "none" }
                        }}
                    >
                        <AccordionSummary expandIcon={<ExpandMore />}>
                            <Typography variant="body2" fontWeight={500}>
                                Como obter o App ID
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Typography variant="caption" component="div" color="text.secondary">
                                1. Acesse o painel do LogRocket (app.logrocket.com)
                            </Typography>
                            <Typography variant="caption" component="div" color="text.secondary">
                                2. Selecione o seu projeto
                            </Typography>
                            <Typography variant="caption" component="div" color="text.secondary">
                                3. Em <b>Project Settings &gt; Setup</b>, copie o App ID exibido na chamada <code>LogRocket.init(&apos;...&apos;)</code>
                            </Typography>
                        </AccordionDetails>
                    </Accordion>
                </Box>
            </SecaoConfiguracao>

            <Snackbar
                open={snackbarOpen}
                autoHideDuration={3000}
                onClose={fecharSnackbar}
                message={snackbarMessage}
            />
        </>
    );
};
